import { useChangeAvatarMutation } from '@http';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

const avatars = [1, 2, 3, 4, 5, 6, 7, 8];

export function Avatars() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Settings' });
  const { mutateAsync } = useChangeAvatarMutation();
  const { userData, refetch } = useAppStore();

  const setAvatar = (avatar: number) => async () => {
    await mutateAsync({ avatar: `avatar${avatar}` });
    refetch();
  };

  const hasPremium = userData.premiumUntil
    && new Date(userData.premiumUntil) >= new Date();

  return (
    <>
      <p className="text-sm text-gray-500 mt-6 mb-1">{t('avatar')}</p>

      {!hasPremium && (
        <p className="text-sm text-gray-500 mt-2">{t('avatarLocked')}</p>
      )}

      {hasPremium && (
        <div className="grid grid-cols-5 gap-2">
          {avatars.map((avatar) => (
            <button
              className={`${userData.avatar === `avatar${avatar}` && 'border-2 border-primary'} w-full aspect-square`}
              onClick={setAvatar(avatar)}
              key={avatar}
            >
              <img
                src={`/img/avatars/avatar${avatar}.avif`}
                className="w-full h-full object-cover"
                alt="Avatar"
              />
            </button>
          ))}
        </div>
      )}
    </>
  );
}